/* global routes */

(function () {
  if (customElements.get('shipping-protection')) return;

  class ShippingProtection extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;

      this.variantId = this.dataset.variantId;
      this.lineKey = this.dataset.lineKey || '';

      this.boundOnChange = this.onChange.bind(this);
      this.checkbox.addEventListener('change', this.boundOnChange);
    }

    disconnectedCallback() {
      if (this.checkbox && this.boundOnChange) {
        this.checkbox.removeEventListener('change', this.boundOnChange);
      }
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      if (this.checkbox) this.checkbox.disabled = isLoading;
    }

    getSectionsToRender() {
      var cart = document.querySelector('cart-items');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender();
      }
      return [
        { id: 'main-cart-items', section: 'main-cart-items', selector: '.js-contents' },
        { id: 'main-cart-footer', section: 'main-cart-footer', selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }

    getSectionInnerHTML(html, selector) {
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return parsed ? parsed.innerHTML : '';
    }

    renderSections(parsedState) {
      if (!parsedState || !parsedState.sections) return;
      this.getSectionsToRender().forEach(function (section) {
        var host = document.getElementById(section.id);
        if (!host) return;
        var elementToReplace = host.querySelector(section.selector) || host;
        var html = parsedState.sections[section.section];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (!parsed) return;
        elementToReplace.innerHTML = parsed.innerHTML;
      });

      var itemCount = parsedState.item_count;
      if (typeof itemCount === 'number') {
        var cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.classList.toggle('is-empty', itemCount === 0);
        var cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.toggle('is-empty', itemCount === 0);
      }
    }

    async onChange() {
      if (!this.variantId) return;

      this.setLoading(true);
      try {
        var data = this.checkbox.checked ? await this.addLine() : await this.removeLine();
        this.renderSections(data);
      } catch (err) {
        console.error('[shipping-protection]', err);
        this.checkbox.checked = !this.checkbox.checked;
      } finally {
        this.setLoading(false);
      }
    }

    async addLine() {
      var addUrl = (typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
      var sections = this.getSectionsToRender().map(function (s) { return s.section; });
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(this.variantId, 10), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      var data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add failed');
      }
      return data;
    }

    async removeLine() {
      if (!this.lineKey) return null;
      var changeUrl = (typeof routes !== 'undefined' && routes.cart_change_url ? routes.cart_change_url : '/cart/change') + '.js';
      var sections = this.getSectionsToRender().map(function (s) { return s.section; });
      var response = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: this.lineKey,
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      var data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Remove failed');
      }
      return data;
    }
  }

  customElements.define('shipping-protection', ShippingProtection);
})();
